import { call, put } from 'redux-saga/effects';

import { callAPI, METHODS } from '../api';

import { setEnvironmentVariables } from '../../effects/application';

export default function* getEnvironmentVariables() {
  const { success, error, result } = yield call(callAPI, {
    authorization: false,
    url: '/environment.json',
    method: METHODS.GET,
  });
  if (success && !error) {
    yield put(setEnvironmentVariables(result));
  }
}
